import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "aesthetic-os-token";
const REFRESH_KEY = "aesthetic-os-refresh";

export const tokenStore = {
  get: () => localStorage.getItem(TOKEN_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_KEY),
  set: (access, refresh) => {
    if (access) localStorage.setItem(TOKEN_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((config) => {
  const t = tokenStore.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// One-shot refresh on 401, then retry once.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const refresh = tokenStore.getRefresh();
    const used = String(original?.headers?.Authorization || "").replace("Bearer ", "");
    const current = tokenStore.get();
    // Token già sostituito (es. dopo cambio password): riprova con quello nuovo, non sloggare.
    if (error.response?.status === 401 && current && used && used !== current && !original._retry) {
      original._retry = true;
      original.headers.Authorization = `Bearer ${current}`;
      return api(original);
    }
    if (error.response?.status === 401 && refresh && !original._retry) {
      original._retry = true;
      try {
        refreshing = refreshing || axios.post(`${BASE}/api/auth/refresh`, { refresh_token: refresh });
        const { data } = await refreshing;
        refreshing = null;
        tokenStore.set(data.access_token, null);
        original.headers.Authorization = `Bearer ${data.access_token}`;
        return api(original);
      } catch (e) {
        refreshing = null;
        if (tokenStore.getRefresh() === refresh) tokenStore.clear();
      }
    }
    return Promise.reject(error);
  }
);

export const apiErr = (e, fallback = "Si è verificato un errore.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || fallback;
};
